import { SwedishPuzzleModel } from './swedish-game.model';

export class PersistUserInput {
  static readonly type = '[SwedishGame] Persist userInput';
  constructor(public payload: { puzzleID: string; userInput: { [key: number]: string } }) {}
}

export class SaveUserInput {
  static readonly type = '[SwedishGame] Save userinput';
  constructor(public payload: { puzzleID: string; index: number; letter: string }) {}
}

// export class SwedishGameMultiTabSync {
//   static readonly type = '[SwedishGame] Sync browser tabs';
//   constructor(public payload: Array<SwedishPuzzleModel>) {}
// }

export class InitSwedishGame {
  static readonly type = '[SwedishGame] Init';
  constructor(public payload: SwedishPuzzleModel) {}
}
